import Work from './work'

export default class Works {

    private readonly works : Array<Work>
    private readonly worksBySection: Map<string, Array<Work>>
    private readonly sections: Array<string>

    public static readonly Instance : Works = new Works()

    private constructor() {
        this.worksBySection = new Map()
        this.sections = []
        this.works = [
            new Work("Fowey", "harbours", true, 0),
            new Work("Fowey2", "harbours", true, 0),
            new Work("LowTideAtPortlooe", "harbours", false, 0),
            new Work("PadstowHarbour2", "harbours", true, 0),
            new Work("FoweyRiverFront", "harbours", true, 0),
            new Work("DaysGoneBy", "harbours", true, 0),
            new Work("BoatsAtLowTide", "harbours", true, 0),
            new Work("OldBoats", "harbours", false, 0),
            new Work("StaithesHarbour", "harbours", true, 0),
            new Work("CatchOfTheDay", "harbours", true, 0),
            new Work("Portloe",  "harbours", true, 0),
            new Work("PrimeCellars", "harbours", false, 0),
            new Work("HayOnWye", "harbours", true, 0),
            new Work("FishermansCottages", "harbours", true, 0),
            new Work("HarbourBoats", "harbours", false, 0),
            new Work("PenberthCove",  "harbours", true, 0),
            new Work("Clovelly", "harbours", false, 0),
            new Work("HousesAtPittenweem", "harbours", false, 0),
            new Work("MistRollingInFromTheSea", "harbours", true, 0),
            new Work("StIvesBoats", "harbours", true, 0),
            new Work("TheRaceClifton", "harbours", false, 0),
            new Work("HealingBlossomTree", "landscapes", false, 1250),
            new Work("WinterFields", "landscapes", false, 0),
            new Work("SecondDustingOfSnow", "landscapes" , true, 0),
            new Work("SummerMeadow", "landscapes", false, 0),
            new Work("PatchworkFields", "landscapes", false, 0),
            new Work("SailingBoatsAtRock", "landscapes", false, 0),
            new Work("TheHarvest", "landscapes", false, 0),
            new Work("FieldsAtTurville", "landscapes" , true, 0),
            new Work("YellowFieldsForever", "landscapes" , true, 0),
            new Work("BlueGondolas",  "italy", true, 0),
            new Work("VeniceDoorway",  "italy", true, 0),
            new Work("RioMaggiore",  "italy", true, 0),
            new Work("GrandCanal", "italy", true, 0),
            new Work("GrandCanal2", "italy", false, 0),
            new Work("GrandCanal3", "italy", true, 0),
            new Work("ReflectionsOfVenice", "italy", false, 0),
            new Work("SunsetVeniceCanal", "italy", false, 0),
            new Work("VeniceAlleyway", "italy", false, 0),
            new Work("ManarolaItaly",  "italy", true, 0),
            new Work("BostonHarbour",  "cities", true, 0),
            new Work("GlitteringLondonLights",  "cities", true, 0),
            new Work("LondonAerial",  "cities", true, 0),
            new Work("TheTower",  "cities", true, 0),
        ]
        this.works.forEach(work => {
            let sectionWorks = this.worksBySection.get(work.section)
            if(sectionWorks === undefined) {
                sectionWorks = []
                this.worksBySection.set(work.section, sectionWorks)
            }
            sectionWorks.push(work)
            if(this.sections.find(section => section === work.section) === undefined) {
                this.sections.push(work.section)
            }
        })
    }

    getSections() : Array<string> {
        return this.sections
    }

    inSection(
        section : string
    ) : Array<Work> {
        const works = this.worksBySection.get(section)
        if(works === undefined) {
            throw new Error(`There are no works in section: ${section}`)
        }
        return works
    }
}
